export enum SubmissionFieldScopeType {
  WorkspaceItem = 'SUBMISSION',
  WorkflowItem = 'WORKFLOW',
}
